import router from "../router";

export default {
  methods: {
    moveTo(to) {
      if (this.$route.path !== to) {
        this.$router.push(to).catch(() => {});
      }
    },
    isURL(str) {
      const regexp = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,9}(:[0-9]{1,5})?(\/.*)?$/gim;
      return regexp.test(str);
    },
    getLoggedUser() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));

      if (user) {
        return user;
      }

      return null;
    },

    isAdmin() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));

      if (user && user.role === "admin") {
        return true;
      }

      return false;
    },

    isDealer() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));

      if (user && user.role === "dealer_contact") {
        return true;
      }

      return false;
    },

    isArchitect() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));

      if (user && user.role === "architect") {
        return true;
      }

      return false;
    },

    isContractor() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));

      if (user && user.role === "contractor") {
        return true;
      }

      return false;
    },

    getUserAccessToken() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));
      let token = null;

      if (user) {
        token = user.access_token;
      }

      return token;
    },

    getRefreshToken() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));
      let token = null;

      if (user) {
        token = user.refresh_token;
      }

      return token;
    },

    redirectUser(user) {
      if (user && user.role === "admin") {
        router.push("/admin-users").catch(() => {});
      } else if (user && user.role === "dealer_contact") {
        router.push("/dealer/rfq").catch(() => {});
      } else {
        router.push("/").catch(() => {});
      }
    },

    logoutUser() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));

      if (user) {
        localStorage.removeItem(process.env.VUE_APP_USER);
      }

      this.moveTo("/auth/signin");
    },

    removeUser() {
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER));

      if (user) {
        localStorage.removeItem(process.env.VUE_APP_USER);
      }
    }
  }
};
